import { PlateWarning } from '../../enums/plate.enums';

export interface IPlateLoc {
  /** in feet, + is towards first base from batter's POV */
  plate_x: number;
  /** in feet, + is higher from the ground */
  plate_z: number;
}

export interface IPlateLocExt extends IPlateLoc {
  _created: string;
  _id: string;

  // e.g. if we want to differentiate between shots for aiming vs analysis in data collector
  aiming?: boolean;
}

export const DEFAULT_PLATE: IPlateLoc = {
  plate_x: 0,
  plate_z: 2.5,
};

export interface ISafeLocation {
  // undefined => no recommendation (i.e. do not change the target for the user)
  location: IPlateLoc | undefined;
  warning: PlateWarning;
}
